import { render, staticRenderFns } from "./InventoryRequestEditForm.vue?vue&type=template&id=5edc80de&"
import script from "./InventoryRequestEditForm.vue?vue&type=script&lang=js&"
export * from "./InventoryRequestEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports